import { alertActions } from "../actions/alert.actions";
import { fetchAsPost } from "./api.service";
import { handleResData } from "./api.handleRespone";
import { API_CUSTOMER } from "../helpers/apiURL";
import Moment from "moment";

export async function fetchCustomers(params, dispatch) {
  const res = await fetchAsPost(API_CUSTOMER.GET, params);
  return handleResData(res, dispatch);
}

export async function fetchCusSetting(dispatch) {
  const res = await fetchAsPost(API_CUSTOMER.INFO);
  return handleResData(res, dispatch);
}

export async function fetchCheckLimitSF(params, dispatch) {
  const res = await fetchAsPost(API_CUSTOMER.SF_CHECK_LIMIT, params);
  if (!res.isInvalid || res.isOk) {
    return res;
  }

  const { error_code, message } = res.errors;
  dispatch(
    alertActions.error({ error_code, message: Object.values(message)[0] })
  );

  return res;
}

export async function fetchBulkImportSF(params, dispatch) {
  const res = await fetchAsPost(API_CUSTOMER.SF_UPDATE, params);
  return handleResData(res, dispatch, true);
}

export async function fetchCheckLimitKT(params, dispatch) {
  const res = await fetchAsPost(API_CUSTOMER.KT_CHECK_LIMIT, params);

  if (!res.isOk && res.isInvalid) {
    const { error_code, message } = res.errors;
    dispatch(
      alertActions.error({ error_code, message: Object.values(message)[0] })
    );
  }

  return res;
}

export async function fetchBulkImportKT(params, dispatch) {
  const res = await fetchAsPost(API_CUSTOMER.KT_UPDATE, params);
  return handleResData(res, dispatch, true);
}

export async function fetchBulkImportEC(params, dispatch) {
  const res = await fetchAsPost(API_CUSTOMER.EC_IMPORT, params);
  return handleResData(res, dispatch, true);
}

export async function fetchCusExport(params, dispatch) {
  const res = await fetchAsPost(API_CUSTOMER.EXPORT_CSV, params);

  if (!res.isInvalid) {
    return res;
  }

  if (!res.isOk && res.isInvalid) {
    const { error_code, message } = res.errors;
    dispatch(
      alertActions.error({ error_code, message: Object.values(message)[0] })
    );
    return res;
  }

  const bodyData = res.data.body.map((expDt) => {
    const telTime = Moment(expDt.tel_time);
    const cTelTime = Moment(expDt.catch_tel_time);

    return {
      ...expDt,
      tel_time: telTime.isValid() ? telTime.format("YYYY-MM-DD HH:mm:ss") : "",
      catch_tel_time: cTelTime.isValid()
        ? cTelTime.format("YYYY-MM-DD HH:mm:ss")
        : "",
    };
  });

  const obj = {
    header: res.data.header,
    body: bodyData,
  };

  return { ...res, data: obj };
}

export async function fetchUpdateSwitch(params, dispatch) {
  const res = await fetchAsPost(API_CUSTOMER.UPDATE_STATUS, params);
  return handleResData(res, dispatch);
}
